// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import style from './CourierInfoMini.scss';
import defaultPic from '../../../../../assets/img/profileplaceholder.jpg';

import type { Courier } from '../../../../../entities';

type Props = {
  +courier: Courier;
};

export default class CourierInfoMini extends Component<Props> {
  render() {
    const { courier } = this.props;
    return (
      <div className={style.courierInfoWrap}>
        <img src={courier.image || defaultPic} 
             alt={courier.name}
             className={style.courierLogo}/>
             <div className={style.textWrap}>
               <FormattedMessage id="order.courierInfo.title">{
                 txt => <p className={style.text}>{txt}</p>
               }</FormattedMessage>
               <p className={style.text}>{courier.name}</p>
             </div>
      </div>
    );
  }
}

CourierInfoMini.propTypes = {
  courier: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/components/CourierInfoMini/CourierInfoMini.jsx